export const reduceReadBoardRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingBoard: true },
  };
};

export const reduceReadBoardSuccess = (state, { payload: { board } }) => {
  if (!board) return { ...state, ui: { ...state.ui, isFetchingBoard: false } };

  // using mongoID as key to keep compatibility with other stores like teams
  const { mongoId } = board;
  const newAllIDs = [
    ...new Set([...(state?.base?.allIDs || []), mongoId]),
  ].sort();

  return {
    ...state,
    base: {
      ...state.base,
      allIDs: newAllIDs,
      byId: { ...state.base.byId, [mongoId]: { ...board } },
    },
    ui: { ...state.ui, isFetchingBoard: false },
  };
};

export const reduceReadBoardFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isFetchingBoard: false },
  };
};
